import styles from './ResonanceMark.module.css';

export function ResonanceMark({
  size = 24,
  className,
  tone = 'inherit',
}: {
  size?: number;
  className?: string | undefined;
  tone?: 'inherit' | 'theme' | 'brand';
}) {
  return (
    <span
      className={`${styles.mark} ${styles[tone]}${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
}
